import '../../style/index.less';
import './index.less';

// style dependencies
import '../../empty/style';
import '../../input/style';